import type {
  PreCheckedProvidersContent,
  ExtractedProvidersContent,
} from '../PreCheckedProviders.types'

/**
 * This function extracts the prechecked providers content from the Tile
 * component and returns different JSX components to be used on the tile
 *
 * @param content From the BE
 * @returns ExtractedProvidersContent object containing:
 *
 *   - PreCheckedProvidersArr: array of providers to display on the tile
 *   - IsProfessional: sidecarCodeType === 'Professional'
 *   - IsFacility: sidecarCodeType === 'Facility'
 *   - FacilityProviders: array of facility providers
 *   - ProfessionalProviders: array of professional providers
 */
export const extractPreCheckedProvidersContent = (
  content: PreCheckedProvidersContent,
): ExtractedProvidersContent => {
  const { providers, sidecarCodeType } = content

  const isProfessional = sidecarCodeType === 'Professional'
  const isFacility = sidecarCodeType === 'Facility'

  const professionalProviders =
    providers?.filter(provider => provider.categoryType === 'Professional') ||
    []
  const facilityProviders =
    providers?.filter(provider => provider.categoryType === 'Facility') || []

  // ----------- SubText & Tool Tip Logic -----------
  // precheckedProvidersArr shows the list of providers based on the sidecarCodeType
  let preCheckedProvidersArr = []

  if (isProfessional) {
    preCheckedProvidersArr = professionalProviders
  } else if (isFacility) {
    preCheckedProvidersArr = facilityProviders
  }

  return {
    preCheckedProvidersArr,
    isProfessional,
    isFacility,
    facilityProviders,
    professionalProviders,
  }
}
